module.exports = __webpack_public_path__ + "static/media/screen2.ffadd836.jpg";